 const AppReducer = (state , action) =>{
  switch ( action.type){
    case "ADD_MOVIE_TO_FAV":
      return {
        ...state,
        fav_movies : [action.payload,...state.fav_movies],
      };
    case "REMOVE_MOVIE_FROM_FAV" :
      return{
        ...state,
        fav_movies : state.fav_movies.filter((val)=>val.id !== action.payload),
      };
    default:
      return state;
  };
};

export default AppReducer;